import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let UserAgentMixin = class UserAgentMixin extends Vue {
    get userAgent() {
        return navigator.userAgent;
    }
    get isUserAgentFacebookApp() {
        return /FBAV|FBAN/.test(this.userAgent);
    }
    get isUserAgentAndroid() {
        return /Android/.test(this.userAgent);
    }
    get isUserAgentIos() {
        return /iPhone|iPad/.test(this.userAgent);
    }
    get signInUri() {
        let defaultUrl = '/login/client';
        const affiliateCode = this.$route.query.affiliate_code;
        if (affiliateCode) {
            defaultUrl = `${defaultUrl}?affiliate_code=${affiliateCode}`;
        }
        return `${window.location.origin}${defaultUrl}`;
    }
    goToSignIn(uri = this.signInUri) {
        // Check userAgent; redirect to appropriate link
        if (this.isUserAgentFacebookApp && this.isUserAgentAndroid) {
            this.redirectSignInAndroidDeepLink(uri);
        }
        else if (this.isUserAgentFacebookApp && this.isUserAgentIos) {
            this.redirectSignInIosDeepLink(uri);
        }
        else {
            window.open(uri);
        }
    }
    redirectSignInAndroidDeepLink(uri) {
        uri = uri.replace(/http:\/\/|https:\/\//, '');
        window.open(`intent://${uri}#Intent;action=android.intent.action.VIEW;scheme=http;end;`, '_system');
    }
    redirectSignInIosDeepLink(uri) {
        window.open(uri, '_system');
    }
};
UserAgentMixin = __decorate([
    Component
], UserAgentMixin);
export default UserAgentMixin;
